import {Fragment} from "react";

export const AlarmActionsHeader = ({header}) =>
  <div className="p-[15px] bg-[#273a4a] text-white text-[14px] rounded-t text-center">{header}</div>

export const PageSelector = ({index, selected, onClick}) =>
  <div key={index} onClick={onClick} className={["h-[30px]", "w-[30px]", "box-border","flex", "justify-center", "items-center", "rounded", "print-hide", "border", selected ? "cursor-default" : "cursor-pointer",
    selected ? "bg-[#2f4050] text-white" : "text-black", "ml-1"].join(" ")}>
    {index + 1}
  </div>


export const SignTable = ({name, data, sign}) =>
  <table className="flex-1">
    <thead>
      <tr>
        <th colSpan={12} className="border border-[#e7e7e7] border-collapse text-[#4f4f4f]! bg-[#fafafa] text-[14px]">{name}</th>
      </tr>
      <tr>
        <th colSpan={12} className="border border-[#e7e7e7] border-collapse">
          <div>
              <span className="block">Observação:</span>
              <span className="block font-normal">{data?.obsSign ?? ""}</span>
          </div>
        </th>
      </tr>
    </thead>
    <tbody className="text-[14px]!">
      {data?.questionsSign?.length
        ? <>
          {
            data?.questionsSign.map((item, idx) =>
              <Fragment key={idx}>
                <tr colSpan={12}>
                  <th className="border border-[#e7e7e7] border-collapse text-[#4f4f4f]! bg-[#fafafa] text-start w-[16%]">PERGUNTA:</th>
                  <td className="border border-[#e7e7e7] border-collapse text-[#4f4f4f]! bg-[#fafafa] text-start font-normal!">{item.question}</td>
                </tr>
                <tr colSpan={12}>
                  <th className="text-start">RESPOSTA:</th>
                  <th className="border border-[#e7e7e7] border-collapse  text-start font-normal!">{item.answer?.toUpperCase()}</th>
                </tr>
              </Fragment>)
          }
            <tr><td colSpan={12} className="border border-[#e7e7e7] border-collapse text-[#4f4f4f]! text-center"><span className="font-bold">ASSINATURA:</span><span> {sign}</span></td></tr>
          </>
        : <tr className="border border-[#e7e7e7] border-collapse  "><td><div className="h-full flex items-center justify-center">Sem dados para exibir</div></td></tr>
      }
    </tbody>
  </table>